import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  Text,
  View,
  ActivityIndicator,
  Platform,
} from 'react-native';
import { Button } from 'react-native-elements';
import { matchPath } from 'react-router-dom';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { updateUserAttributes, fetchAuthSession } from '@aws-amplify/auth';
// import { Auth } from '@aws-amplify/auth';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';

import { AppSyncClientAuthenticated } from '../../backends/AppSyncClient';
import GetUser from '../../q/GetUser';
import AddUserImage from '../../q/AddUserImage';
import AORTypes from '../../types';
import styles from '../../styles';
import { translate } from '../../locales/i18n';
import { language, country, locale } from '../../localization';

const DEFAULT_LANDING = '/ai-agents';

class ExternalAuth extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.tryToUpdate = this.tryToUpdate.bind(this);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'ExternalAuth';

    this.state = {
    };

    this.done = false;
  }

  componentDidMount() {
    const {
      location,
      getAnalyticsService,
    } = this.props;
    // const provider = params?.provider;
    // const redirect = params?.redirect;

    const {
      provider,
      redirect,
    } = this.getParams();

    getAnalyticsService().report.event(`auth${provider}`, 'user');

    console.log('location');
    console.log(location);
    console.log('provider');
    console.log(provider);
    console.log('redirect');
    console.log(redirect);

    // update the state to figure out what to render
    const params = [];

    const hashPos = location.hash.indexOf('#');
    if (hashPos !== -1) {
      const hashTail = location.hash.substring(hashPos + 1);
      const hashParams = hashTail.split('&');
      params.push(...hashParams);
    }

    const searchPos = location.search.indexOf('?');
    if (searchPos !== -1) {
      const searchTail = location.search.substring(searchPos + 1);
      const searchParams = searchTail.split('&');
      params.push(...searchParams);
    }

    const stateChanges = params.reduce((acc, item) => {
      const kvPair = item.split('=');
      const key = kvPair[0];
      const value = kvPair[1];

      if (key === 'error') {
        console.log('error');
        console.log(value);
        acc.error = value;
      } else if (key === 'error_description') {
        console.log('errorDescription');
        console.log(value);
        acc.errorDescription = value;
      } else if (key === 'state') {
        console.log('errorState');
        console.log(value);
        acc.errorState = value;
      }

      return acc;
    }, {});

    this.setState(stateChanges, () => {
      // if there was no error, then we need to trigger the state change once
      if (stateChanges.error === undefined) {
        this.tryToUpdate();
      }
    });
  }

  componentDidUpdate(_prevProps, _prevState) {
    this.tryToUpdate();
  }

  getParams() {
    const {
      location,
    } = this.props;

    const pattern = '/auth/:provider/*';
    const match = matchPath(pattern, location.pathname);
    const provider = match?.params?.provider;
    const redirect = match?.params['*'];

    return {
      provider,
      redirect,
    };
  }

  tryToUpdate() {
    const {
      user,
      onUpdateUser,
      updateUserData,
      history,
      getAnalyticsService,
      getUploader,
      onAddUserImage,
    } = this.props;
    let { userData } = this.props;
    const { errorState } = this.state;

    let needsUpdate = false;

    console.log('user');
    console.log(user);
    console.log('userData');
    console.log(userData);

    // get a mutable copy of the userData object
    userData = JSON.parse(JSON.stringify(userData));

    if (!userData || !user) {
      // not ready to decide if anything needs to be done
      return;
    }

    if (this.done) {
      // it's already executed once.
      // we are just getting property updates now.
      // ignore.
      return;
    }
    this.done = true;

    // now we have all the data to decide what needs to be updated

    // 0. locale
    if (!userData.locale || userData.locale === '' || typeof userData.locale === 'boolean') {
      userData.locale = locale;
      needsUpdate = true;
    }

    // 1. country
    if (!userData.country || userData.country === '') {
      // we need to initialize the country
      // do initialize the locate as well
      userData.country = country;
      needsUpdate = true;
    }

    // 2. languages
    const lang = language();
    let langs = [];
    try {
      langs = JSON.parse(userData.langs);
    } catch (_e) {
      // langs is not initialized
    }
    if (langs.length === 0 || langs.indexOf(lang) === -1) {
      // we need to initialize 'userData.langs'
      langs.push(lang);
      userData.langs = JSON.stringify(langs);
      needsUpdate = true;
    }

    // 3. image
    let uploadImageFn = new Promise((resolve) => {
      resolve('skipped');
    });
    if (Platform.OS === 'web'
      && (!userData.image || userData.image === '')
      && user.attributes.picture
      && user.attributes.picture !== '') {
      // we need to import the user image
      console.log('importing user image');
      console.log(user.attributes.picture);
      uploadImageFn = new Promise((resolve) => {
        getUploader().handleUrlUpload(
          user.attributes.uuid,
          user.attributes.picture,
          user.attributes.uuid,
          onAddUserImage,
          updateUserData,
          (success) => {
            resolve(success);
          },
          {}
        );
      });

      // TODO(clairbee): update the user image by downloading the url from 'user' and uploading it
      needsUpdate = true;
    }

    // 4. user name
    if ((!userData.name || userData.name.length < 1) && user.attributes.name && user.attributes.name !== '') {
      userData.name = user.attributes.name;
      needsUpdate = true;
    }

    const {
      redirect,
    } = this.getParams();

    let nextUriConst = (redirect && redirect !== '') ? redirect : DEFAULT_LANDING;
    let nextUriPromise;
    if (nextUriConst === DEFAULT_LANDING) {
      if (errorState && errorState.indexOf('-') !== -1) {
        nextUriConst = decodeURIComponent(errorState.substring(errorState.indexOf('-') + 1));
      } else if (Platform.OS === 'web') {
        nextUriConst = undefined;
        try {
          nextUriPromise = new Promise((resolve, _reject) => {
            AsyncStorage.getItem('oauthState')
              .then((result) => resolve(result))
              .catch(() => resolve(null));
          });
        } catch (_error) {
          nextUriConst = DEFAULT_LANDING;
        }
      }
    }
    console.log('nextUriConst');
    console.log(nextUriConst);
    console.log('nextUriPromise');
    console.log(!!nextUriPromise);
    console.log('errorState');
    console.log(errorState);

    if (!needsUpdate) {
      console.log('no need for an update');
      if (nextUriConst) {
        history.push(nextUriConst);
      } else {
        nextUriPromise.then((nextUri) => {
          console.log('nextUri');
          console.log(nextUri);
          if (nextUri) {
            history.push(nextUri);
          } else {
            history.push(DEFAULT_LANDING);
          }
        });
      }
      return;
    }

    const update = (ud) => onUpdateUser(ud)
      .then((result) => {
        console.log('onUpdateUser');
        console.log(result);

        updateUserData()
          .then(() => {
            uploadImageFn
              .then(() => {
                if (nextUriConst) {
                  history.push(nextUriConst);
                } else {
                  nextUriPromise.then((nextUri) => {
                    if (nextUri) {
                      history.push(nextUri);
                    } else {
                      history.push(DEFAULT_LANDING);
                    }
                  });
                }
              });
          });
      })
      .catch((err) => {
        console.log('onUpdateUser error');
        console.log(err);

        getAnalyticsService().report.event('updateUserFailed', 'user');

        history.push(DEFAULT_LANDING);
      });

    updateUserAttributes({
      userAttributes: {
        preferred_username: user.attributes.name,
        locale,
        'custom:language': lang,
      },
    })
      .then(() => {
        getAnalyticsService().report.event('updateExternalName', 'user');

        user.attributes.preferred_username = user.attributes.name;
        // TODO(clairbee): the below was added for some reason, but it triggered the component update on mobile web
        // Auth.currentAuthenticatedUser({ bypassCache: true });

        userData.name = user.attributes.name;
        update(userData);
      })
      .catch((err) => {
        console.log('updateUserAttributes error');
        console.log(err);

        updateUserAttributes({
          userAttributes: {
            preferred_username: user.attributes.username,
            locale,
            'custom:language': lang,
          },
        })
          .then(() => {
            getAnalyticsService().report.event('updateExternalName2', 'user');

            user.attributes.preferred_username = user.attributes.name;
            try {
              // currentAuthenticatedUser({ bypassCache: true });
              fetchAuthSession();
            } catch (_e) {
              // do nothing. something is happening here for Google Users.
            }

            userData.name = user.attributes.username;
            update(userData);
          })
          .catch((err2) => {
            console.log('updateUserAttributes error2');
            console.log(err2);

            getAnalyticsService().report.event('updateExternalFailed', 'user');

            userData.name = user.attributes.sub;
            update(userData);
          });
      });
  }

  render() {
    const {
      error,
    } = this.state;
    const {
      history,
    } = this.props;

    if (error !== undefined) {
      return (
        <View
          style={styles.view.headless}
        >
          <View
            style={{
              flex: 1,
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Text
              style={{
                marginVertical: 10,
              }}
            >
              {translate('auth_error')}
            </Text>
            <View
              style={{
                flexDirection: 'row',
              }}
            >
              <View
                style={{
                  flex: 1,
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Button
                  title={translate('button_back')}
                  containerStyle={[styles.buttonfsf.primaryContainer, { marginVertical: 30 }]}
                  buttonStyle={styles.buttonfsf.primary}
                  titleStyle={styles.buttonfsf.primaryTitle}
                  onPress={() => { history.go(-1); }}
                  loadingProps={{ size: 'small', color: 'white' }}
                />
              </View>
            </View>
          </View>
        </View>
      );
    }

    return (
      <View
        style={styles.view.headless}
      >
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Text
            style={{
              marginVertical: 10,
            }}
          >
            {translate('auth_initializing')}
          </Text>
          <ActivityIndicator size="large" color={styles.primaryColor} />
        </View>
      </View>
    );
  }
}

ExternalAuth.defaultProps = {
  user: undefined,
  userData: undefined,
};

ExternalAuth.propTypes = {
  user: AORTypes.AWS.Cognito.User,
  userData: AORTypes.User, // can't be 'isRequired' because of 'skip'
  onUpdateUser: PropTypes.func.isRequired,
  updateUserData: PropTypes.func.isRequired, // can't be 'isRequired' because of 'skip'
  location: ReactRouterPropTypes.location.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  getAnalyticsService: PropTypes.func.isRequired,
  getUploader: PropTypes.func.isRequired,
  onAddUserImage: PropTypes.func.isRequired,
};

export default compose(
  graphql(AddUserImage, {
    // name: 'AddEndpointImage',
    props: (props) => ({
      onAddUserImage: ({
        uuid, name, isVertical, lat, lon, type,
      }) => props.mutate({
        variables: {
          uuid,
          name,
          isVertical,
          lat,
          lon,
          type,
        },
        // TODO(clairbee): optimisticResponse breaks refetchQueries
        // optimisticResponse: () => ({
        //   updateEndpoint:
        //     endpoint.makeOptimistic().output(),
        // }),
      }),
    }),
    options: (props) => ({
      refetchQueries: [{
        query: GetUser,
        variables: { uuid: props.user && props.user.attributes.sub },
        client: AppSyncClientAuthenticated(props.user),
      }],
      // fetchPolicy: 'no-cache',
      client: AppSyncClientAuthenticated(props.user),
    }),
  })
)(ExternalAuth);
